import { Height as Size } from '@atlassian/company-hub-common';

import { type ResourceTilesDimensions } from './types';

export const RESOURCE_TILES_EXTENSION_KEY = 'knowledge-cards';
export const RESOURCE_TILES_EXTENSION_TYPE = 'com.atlassian.confluence.knowledge-cards';
export const RESOURCE_TILES_EXTENSION_VERSION_1 = '1.0.0';
export const RESOURCE_TILES_EXTENSION_ANALYTIC_SOURCE = 'resourceTilesExtension';
export const RESOURCE_TILES_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'resourceTilesExtensionConfig';
export const PAGE_SIZE = 9;

export const RESOURCE_TILES_DIMENSIONS: ResourceTilesDimensions = {
	[Size.SMALL]: {
		minWidth: 240,
		maxWidth: 294,
		height: 84,
	},
	[Size.MEDIUM]: {
		minWidth: 240,
		maxWidth: 294,
		minHeight: 52,
		maxHeight: 328,
	},
	[Size.LARGE]: {
		minWidth: 326,
		maxWidth: 392,
		minHeight: 64,
		maxHeight: 424,
	},
};
